import * as React from "react";
import "./Login.css";
import logo from "../../assets/logo_w.png";
import Slideshow from "./Slideshow";

export default class Login extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      email: "",
      password: "",
      error: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.account = null;
    window.localStorage.setItem("account", "{}");
  }

  handleChange(event: any) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  login() {
    fetch("public/clientLogin", {
      method: "post",
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password,
      }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        console.log(data)
        data.client.type = "client"
        window.localStorage.setItem("account", JSON.stringify(data.client));
        this.props.history.push("/campaigns");
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  public render() {
    return (
      <div id="login-root">
        <div className="right">
          <form>
            <img className="main_logo" src={logo} />
            <h1>כניסה למערכת המכירות</h1>
            <input
              type="email"
              autoFocus
              className="form-control"
              name="email"
              placeholder={"אימייל"}
              value={this.state.email}
              onChange={this.handleChange}
            />
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder={"סיסמה"}
              value={this.state.password}
              onChange={this.handleChange}
            />
            <button
              type="button"
              className={"primary-btn" + (this.validateForm() ? "" : " off")}
              disabled={!this.validateForm()}
              onClick={this.login.bind(this)}
            >
              כניסה
            </button>
            <button
              type="button"
              className={"primary-btn"}
              onClick={() => {
                window.location.href = "/client/signup"
              }}
            >
              הרשמה
            </button>
            <h5>{this.state.error}</h5>
            <div style={{textAlign: "center", width: "80%"}}>

            </div>
          </form>
        </div>
        <Slideshow />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/ClientLogin.tsx